import { atom } from "jotai";

/**
 * The currently-active docs section id (e.g. "overview", "search"). Written by
 * the DocsPage scroll-spy + in-page anchor links, read by the docs table of
 * contents that now lives in the persistent WorkspaceSidebar left rail.
 */
export const docsActiveSectionAtom = atom<string>("overview");
